import React from 'react';
import { Container, Typography, Box, Button, Grid } from '@mui/material';
import YouTubeEmbed from './YouTubeEmbed';
import SocialMediaBar from './SocialMediaBar'; // Re-use the existing SocialMediaBar

const CommunityView = () => {
  // **IMPORTANT: Replace 'dQw4w9WgXcQ' with the actual ID of your desired YouTube video.**
  // You can find the video ID in the URL of your YouTube video (e.g., after v= in youtube.com/watch?v=YOUR_VIDEO_ID_HERE)
  const featuredVideoId = 'Ybb0gKndzt0';
  const featuredVideoTitle = 'Latest MRuns Video';

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 4 }}>
        Join Our Running Community!
      </Typography>

      {/* Featured YouTube Video */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ textAlign: 'center', mb: 3 }}>
          {featuredVideoTitle}
        </Typography>
        <YouTubeEmbed videoId={featuredVideoId} title={featuredVideoTitle} />
        <Box sx={{ textAlign: 'center', mt: 2 }}>
          <Button
            variant="contained"
            color="primary"
            href="https://www.youtube.com/@MarathonRuns" // Replace with your actual YouTube channel URL
            target="_blank"
            rel="noopener noreferrer"
            size="large"
          >
            Visit Our YouTube Channel
          </Button>
        </Box>
      </Box>

      {/* Other Social Media Links */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ textAlign: 'center', mb: 3 }}>
          Connect With Us
        </Typography>
        <SocialMediaBar /> {/* Re-using the existing social media icons */}
        <Typography variant="body1" color="text.secondary" align="center" sx={{ mt: 2 }}>
          Follow us on all our platforms to stay updated with the latest runs, stories, and community events!
        </Typography>
      </Box>

      {/* Placeholder for future embedded feeds (e.g., Facebook, Instagram, Twitter) */}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h4" component="h2" gutterBottom sx={{ textAlign: 'center', mb: 3 }}>
          More From Our Feeds (Coming Soon!)
        </Typography>
        <Typography variant="body1" color="text.secondary" align="center">
          We're working on bringing live feeds from Facebook, Instagram, and Twitter directly to this page. Stay tuned!
        </Typography>
      </Box>
    </Container>
  );
};

export default CommunityView;
